import { useLocation } from 'react-router-dom';
import TextWinds from '../../../components/common/TextWinds';
import '../../../styles/mypage/mypage.css';
import { orderDetailType } from '../../../constants/types/mypage-type';
import OrderDetailLayout from './OrderDetailLayout';
import { OrderStatusLabelEnum } from '../../../enum';
import { numberWithCommas } from '../../../api/utils/format/numbers';
import { TransactionBase } from '../../../constants/types';

const RefundCancelInfo = ({
  orderDetail,
}: {
  orderDetail: orderDetailType;
}) => {
  // const location = useLocation();
  // const orderDetail = location.state;
  const refuncInfo = (() => {
    const transaction = orderDetail.transactions.find(
      (transaction: TransactionBase) => transaction.is_refund,
    );

    return {
      accountNo: transaction?.accountNo,
      bankName: transaction?.bankName,
      depositName: transaction?.depositName,
    };
  })();

  return (
    <OrderDetailLayout title="환불/취소 정보">
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          처리 상태
        </TextWinds>
        <TextWinds type="content_body4">
          {OrderStatusLabelEnum[orderDetail.status]}
        </TextWinds>
      </div>
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          취소 금액
        </TextWinds>
        <TextWinds type="content_body4">
          {numberWithCommas(orderDetail.template.total_price)} 원
        </TextWinds>
      </div>
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          환불 정보
        </TextWinds>
        <TextWinds type="content_body4">
          {refuncInfo.bankName} {refuncInfo.accountNo} {refuncInfo.depositName}
        </TextWinds>
      </div>
    </OrderDetailLayout>
  );
};

export default RefundCancelInfo;
